import React from "react";
import { isDesktop } from "../../utils";
import ProductListTopbarDesktop from "./Desktop";

function ProductListTopbar() {
  if (isDesktop) {
    return <ProductListTopbarDesktop />;
  }
  return null;
}
export default ProductListTopbar;



// WEBPACK FOOTER //
// ./src/component/ProductListTopbar/index.js